/**
 * What an eval decided, as a short value: the verdict's score (0.95), else
 * the one answer its last step gave — a category (poor) or a number. Null
 * when there is nothing single to show (several fields, no answer, an
 * errored step) or when it is only true/false: beside Pass or Fail that says
 * nothing, and in a Triage eval the last step's "false" beside a Pass reads
 * as a contradiction. Shared by the results list and the trace views.
 */
const num = (x) => String(Number(Number(x).toFixed(3)));

function valueOf(v) {
  if (v === null || v === undefined) return null;
  const vals = typeof v === 'object' && !Array.isArray(v) ? Object.values(v) : [v];
  if (vals.length !== 1) return null;
  const x = vals[0];
  if (typeof x === 'number' && Number.isFinite(x)) return num(x);
  if (typeof x === 'boolean') return null;
  return typeof x === 'string' && x ? x : null;
}

export function decisionText(run) {
  if (!run) return null;
  if (run.score !== null && run.score !== undefined && run.score !== '' && Number.isFinite(Number(run.score))) return num(run.score);
  if (run.decision !== undefined) return valueOf(run.decision);
  // A verdict with its journal (the trace views): the last step that answered.
  const steps = Array.isArray(run.steps) ? run.steps : [];
  for (let i = steps.length - 1; i >= 0; i -= 1) {
    const s = steps[i];
    if (s.error) continue;
    const v = s.value !== undefined ? s.value : s.output?.value;
    if (v !== undefined && v !== null) return valueOf(v);
  }
  return null;
}
